import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'How does the subscription work?',
    answer: 'Our subscription service delivers fresh flowers to your specified address on a schedule you choose - weekly, bi-weekly, or monthly. You can customize your preferences, pause, or modify your subscription at any time through your account dashboard.'
  }, {
    question: 'What areas do you deliver to?',
    answer: "We currently deliver to major urban areas in Kenya including Nairobi, Mombasa, and Kisumu. We're constantly expanding our delivery zones. Enter your location during sign-up to confirm availability in your area."
  }, {
    question: 'Can I customize the flowers in my subscription?',
    answer: 'Absolutely! During sign-up, you can select your preferred flower types, colors, and styles. You can also update these preferences at any time from your account settings.'
  }, {
    question: 'What if I need to skip a delivery?',
    answer: 'No problem! You can easily pause or skip deliveries through your account dashboard. We just ask for at least 48 hours notice before your scheduled delivery date.'
  }, {
    question: 'How do you ensure the flowers stay fresh?',
    answer: 'We source our flowers directly from local farms and deliver them within hours of cutting. Each delivery includes flower food and care instructions to maximize vase life. Our Premium and Standard plans also include special care kits.'
  }, {
    question: 'What payment methods do you accept?',
    answer: 'We accept M-PESA, credit/debit cards, and bank transfers. All subscriptions are billed automatically according to your selected frequency.'
  }];
  const [openIndex, setOpenIndex] = useState(0);
  return <section id="faq" className="py-16 bg-gray-50" data-id="element-107">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-110">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-xl text-gray-600" data-id="element-111">
            Everything you need to know about our flower subscription service
          </p>
        </div>
        <div className="space-y-4" data-id="element-112">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-113">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-114">
                <span className="text-lg font-medium text-gray-900" data-id="element-115">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-pink-700" data-id="element-116" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-117" />}
              </button>
              {openIndex === index && <div className="px-6 pb-4" data-id="element-118">
                  <p className="text-gray-600" data-id="element-119">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-120">
          <p className="text-gray-600 mb-4" data-id="element-121">
            Still have questions? We're here to help!
          </p>
          <button className="px-6 py-3 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-122">
            Contact Support
          </button>
        </div>
      </div>
    </section>;
}